import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";

// img
import logo from "../../../assets/svg/jiophotos-logo.svg";
// import jioSnapLogo from "../../../assets/svg/Jiosnap.svg";

// css
import classes from "./Header.module.css";
import Navbar from "./Navbar";
import { Text } from "@jds/core";

export default function Header(props) {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  return (
    <header className="header">
      <div className={classes["header__container"]}>
        <NavLink
          to={!isAuthenticated ? "/" : "/home"}
          className={classes["header__logo-box"]}
          style={{ height: 'fit-content' }}
        >
          {/* <img src={logo} alt="jio photos logo" /> */}
          <Text text="JioEvents" appearance="heading-xs" color="white" />
        </NavLink>
        <Navbar />
      </div>
    </header>
  );
}
